var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vSelect',{staticClass:"custom-v-select",attrs:{"value":_vm.valueChild,"options":_vm.colors,"filter":_vm.filter,"disabled":_vm.disabled},scopedSlots:_vm._u([{key:"selected-option",fn:function(ref){
var name = ref.name;
var color = ref.color;
return [_c('span',{style:(("background-color: " + color + ";"))}),_vm._v(" "+_vm._s(name)+" ")]}},{key:"option",fn:function(ref){
var name = ref.name;
var color = ref.color;
return [_c('div',{staticClass:"w-100",on:{"click":function($event){return _vm.userClick({ name: name, color: color })}}},[_c('span',{style:(("background-color: " + color + ";"))}),_vm._v(" "+_vm._s(name)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }